/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 编辑消息开关
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  messageDto: member.MessageDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/edit`,
    data: messageDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
